import {
  CountryCode,
  Currency,
  Language,
  StoreId,
} from "@ubnt/store.core/lib/types";

// #############################################################################
// Stores info
// #############################################################################
export const STORE_INFO_USA = {
  id: StoreId.Us,
  defaultCurrency: Currency.Usd,
  countries: [
    CountryCode.Us,
    CountryCode.Pr,
    CountryCode.Pw,
    CountryCode.Gu,
    CountryCode.As,
    CountryCode.Vi,
    CountryCode.Mp,
    CountryCode.Mh,
    CountryCode.Fm,
  ],
  // label: "USA Store",
};

/**
 * USA store is always the first item and is always present
 */
export const STORE_INFO_MAPPING = [
  STORE_INFO_USA,
  {
    id: StoreId.Eu,
    defaultCurrency: Currency.Eur,
    countries: [
      CountryCode.At,
      CountryCode.Be,
      CountryCode.Bg,
      CountryCode.Hr,
      CountryCode.Cy,
      CountryCode.Cz,
      CountryCode.Dk,
      CountryCode.Ee,
      CountryCode.Fi,
      CountryCode.Fr,
      CountryCode.De,
      CountryCode.Gr,
      CountryCode.Es,
      CountryCode.Hu,
      CountryCode.Is,
      CountryCode.Ie,
      CountryCode.It,
      CountryCode.Lv,
      CountryCode.Li,
      CountryCode.Lt,
      CountryCode.Lu,
      CountryCode.Mt,
      CountryCode.Mc,
      CountryCode.Nl,
      CountryCode.No,
      CountryCode.Pl,
      CountryCode.Pt,
      CountryCode.Ro,
      CountryCode.Rs,
      CountryCode.Sk,
      CountryCode.Si,
      CountryCode.Se,
      CountryCode.Ch,
      CountryCode.Ax,
      CountryCode.Ad,
      CountryCode.Ba,
      CountryCode.Fo,
    ],
    // label: "Europe Store",
  },
  {
    id: StoreId.Ca,
    defaultCurrency: Currency.Cad,
    countries: [CountryCode.Ca],
    // label: "Canada Store",
  },
  {
    id: StoreId.Me,
    defaultCurrency: Currency.Aed,
    countries: [CountryCode.Ae],
    // label: "Middle East Store",
  },
  {
    id: StoreId.Za,
    defaultCurrency: Currency.Zar,
    countries: [CountryCode.Za],
    // label: "South Africa Store",
  },
  {
    id: StoreId.Uk,
    defaultCurrency: Currency.Gbp,
    countries: [CountryCode.Gb, CountryCode.Im, CountryCode.Gg, CountryCode.Je],
    // label: "United Kingdom Store",
  },
  {
    id: StoreId.Sg,
    defaultCurrency: Currency.Sgd,
    countries: [CountryCode.Sg],
    // label: "Singapore Store",
  },
  {
    id: StoreId.In,
    defaultCurrency: Currency.Inr,
    countries: [CountryCode.In],
    // label: "India Store",
  },
  {
    id: StoreId.Jp,
    defaultCurrency: Currency.Jpy,
    countries: [CountryCode.Jp],
  },
  {
    id: StoreId.Br,
    defaultCurrency: Currency.Brl,
    countries: [CountryCode.Br],
  },
  {
    id: StoreId.Tw,
    defaultCurrency: Currency.Twd,
    countries: [CountryCode.Tw],
  },
  {
    id: StoreId.Ph,
    defaultCurrency: Currency.Php,
    countries: [CountryCode.Ph],
  },
  {
    id: StoreId.Mx,
    defaultCurrency: Currency.Mxn,
    countries: [CountryCode.Mx],
  },
];

// #############################################################################
// Languages
// #############################################################################
export const COUNTRY_LANGUAGE_MAPPING: [Language, Set<CountryCode>][] = [
  [
    Language.Zh,
    new Set([
      CountryCode.Us,
      CountryCode.Mx,
      CountryCode.Es,
      CountryCode.Co,
      CountryCode.Ar,
      CountryCode.Cr,
      CountryCode.Br,
      CountryCode.Pt,
      CountryCode.Sa,
      CountryCode.Jo,
      CountryCode.Qa,
      CountryCode.Ae,
      CountryCode.Fr,
      CountryCode.Gr,
      CountryCode.Jp,
      CountryCode.It,
      CountryCode.De,
      CountryCode.Cn,
    ]),
  ],
];
